import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { onMounted, reactive, ref, toRefs, watch } from "vue";
import apis from "@/api";
import AssetsCard from "./components/AssetsCard.vue";
import AssetsTable from "./components/AssetsTable.vue";
export default {
  components: {
    AssetsCard,
    AssetsTable
  },
  setup() {
    const assetsTableRef = ref({});
    const assetsCardRef = ref({});
    const data = reactive({
      loading: false,
      choseAsset: {},
      form: {
        posName: "",
        tagNum: "",
        tagName: "",
        keys: "",
        subtype: "",
        offerId: "",
        needUser: "",
        busiLink: "",
        srcTyp: "",
        status: 1,
        pageSize: 20,
        pageNum: 1
      },
      posData: [],
      assetsList: [],
      total: 0,
      activeName: '0',
      assetsCardSelectedIds: new Set()
    });
    const cascader = {
      label: "nodeName",
      value: "nodeName",
      children: "children",
      emitPath: false,
      checkStrictly: false
    };
    const fetchData = () => {
      data.loading = true;
      apis.assetsSearch(data.form).then(res => {
        if (res.success) {
          data.assetsList = res.data.assets;
          data.total = res.data.total;
          data.assetsList.forEach(val => {
            val.check = false; // 默认未选中
            data.assetsCardSelectedIds.clear();
          });
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    onMounted(() => {
      apis.queryPositionTree("").then(res => {
        if (res.success) {
          data.posData = res.data;
        }
      });
    });
    watch(() => data.form.pageNum, fetchData, {
      immediate: true
    });
    const onSubmit = () => {
      fetchData();
    };
    const reset = () => {
      data.form = Object.assign(data.form, {
        posName: "",
        tagNum: "",
        tagName: "",
        keys: "",
        subtype: "",
        offerId: "",
        needUser: "",
        busiLink: "",
        srcTyp: "",
        status: 1
      });
      fetchData();
    };
    const posChange = e => {
      console.log(e);
    };
    const tabsClick = (tab, event) => {
      data.activeName = tab.index;
    };
    const handleBatchUpdateAssetsStatus = p => {
      if (data.activeName === '0') {
        // 卡片模式
        assetsCardRef.value.batchUpdateAssetsStatus(p, Array.from(data.assetsCardSelectedIds));
      } else if (data.activeName === '1') {
        assetsTableRef.value.batchUpdateAssetsStatus(p);
      }
    };
    const selectChange = item => {
      data.assetsList.forEach(val => {
        if (val.id == item.id) {
          if (val.check) {
            val.check = false;
            data.assetsCardSelectedIds.delete(item.id);
          } else {
            val.check = true;
            data.assetsCardSelectedIds.add(item.id);
          }
        }
      });
    };
    return {
      ...toRefs(data),
      cascader,
      onSubmit,
      reset,
      posChange,
      fetchData,
      tabsClick,
      handleBatchUpdateAssetsStatus,
      assetsTableRef,
      assetsCardRef,
      selectChange
    };
  }
};